export default __webpack_public_path__ + "static/media/right-arrow.c040b56c.svg";